module.exports = __webpack_public_path__ + "img/Weapon_226.52f1e209.png";